import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Button.css';
import { motion } from 'framer-motion';

const Button = ({
  onClick,
  type = 'button',
  variant = 'primary',
  size = 'medium',
  label,
  isLoading = false,
  fullWidth = false,
  disabled = false,
  className = '',
  icon,
  children,
  arrowContainerColor,
}) => {
  const arrowStyle = arrowContainerColor
    ? { backgroundColor: arrowContainerColor }
    : {};

  const buttonClass = [
    'button',
    variant,
    size,
    fullWidth ? 'fullWidth' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

 return (
<motion.button
  className={buttonClass}
  onClick={onClick}
  type={type}
  disabled={isLoading || disabled}
  initial={false}
  animate={
    variant === 'primary' && !disabled
      ? {
          boxShadow: [
            '0 0 0 rgba(59,130,246,0)',
            '0 0 24px rgba(59,130,246,0.35)',
            '0 0 0 rgba(59,130,246,0)',
          ],
        }
      : {}
  }
  transition={{
    duration: 2.5,
    repeat: Infinity,
    ease: 'easeInOut',
  }}
  whileHover={
    variant === 'primary' && !disabled
      ? {
          scale: 1.05,
          background:
            'linear-gradient(135deg, #2563eb, #60a5fa)',
          boxShadow:
            '0 20px 40px rgba(96,165,250,0.55)',
        }
      : {}
  }
  whileTap={
    variant === 'primary' && !disabled
      ? { scale: 0.96 }
      : {}
  }
>


      {icon && <span className="iconContainer">{icon}</span>}
      {children ? (
        <span>{children}</span>
      ) : (
        <span className="label">{label}</span>
      )}
      {variant !== 'auth' && (
        <div className="arrowContainer" style={arrowStyle}>
          <i className="bi bi-chevron-right arrowIcon" />
        </div>
      )}
  </motion.button>  );
};

export default Button;
